
import React, { useState } from 'react';
import SidebarDash from '../../Pages/Dashboard/SidebarDash'; 
import { Outlet } from 'react-router-dom';

export default function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-[var(--bg-black)]">
      <SidebarDash isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
      <main className="flex-1 ml-0 md:ml-16 lg:ml-20 xl:ml-24 transition-all duration-300">
        <Outlet /> 
      </main>
    </div>
  );
}